import { forwardRef, Injectable } from '@angular/core'
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { CustomValidators } from '@se-po/shared-data-access-validators'

@Injectable({
  providedIn: 'root',
  useExisting: forwardRef(() => SelfInfoFormService),
  deps: [FormBuilder]
})
export abstract class SelfInfoForm {
  public abstract form: UntypedFormGroup
  public abstract createForm(): void
}

@Injectable({
  providedIn: 'root'
})
export class SelfInfoFormService implements SelfInfoForm {
  public form: UntypedFormGroup

  constructor(
    private fb: FormBuilder,
  ) {}

  public createForm(): void {
    this.form = this.fb.group({
      accountInfo: {},
      contactInfo: [{
        email: '',
        phone: '',
      }]
    })
  }
}
